import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const activitiesApi = createApi({
  reducerPath: 'activitiesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Activities', 'ActivitiesId'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
